import React from 'react';
import { Link } from 'react-router-dom';

export default function Products() {
  const doctorProducts = [
    { name: "Dr John Bushra", link: "https://drjohnweb.safehandapps.com" },
    { name: "Dr Mostafa Hashem", link: "https://drhashimweb.safehandapps.com" },
    { name: "Dr Maged Algebaly", link: "https://drmagedelgballyweb.safehandapps.com" },
    { name: "Dr Mohamed Hossam", link: "https://drmohamedhossamweb.safehandapps.com" },
    { name: "Dr Mahmoud Hamdy", link: "https://drmahmoudhamdiweb.safehandapps.com" },
    { name: "Dr Ahmed Yassin", link: "https://drahmedyassinweb.safehandapps.com" },
    { name: "Dr Hany Abo Taleb", link: "https://drhaniabotalebweb.safehandapps.com" },
    { name: "Dr Mostafa Abdalla", link: "https://drmostafaabdhallaweb.safehandapps.com" },
    { name: "Dr Ahmed Almalla", link: "https://drelmallaweb.safehandapps.com" },
    { name: "Dr Mohamed Salah", link: "https://drmsalahweb.safehandapps.com" },
    { name: "aqar alminya", link: "http://aqaratweb.3qaronline.com" }
  ];

  const products = [
 
    ...doctorProducts.map(doctor => ({
      name: doctor.name,
      description: "Professional doctor profile and appointment booking system",
      link: doctor.link
    }))
  ];

  return <>
  <div className="container-fluid bg-breadcrumb">
        <ul className="breadcrumb-animation">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h3 className="display-3 mb-4" data-aos="fade-down" data-aos-delay="100">Our Products</h3>
          <ol className="breadcrumb justify-content-center mb-0" data-aos="fade-down" data-aos-delay="300">
            <li className="breadcrumb-item"><Link to='/'>Home</Link></li>
            <li className="breadcrumb-item active text-primary">Products</li>
          </ol>
        </div>
      </div>
    <div className="container-fluid blog py-5">
      <div className="container py-5">
        <div
          className="text-center mx-auto mb-5"
          data-aos="fade-up"
          data-aos-delay="100"
          style={{ maxWidth: '900px' }}
        >
          <h4 className="text-primary">Our Products</h4>
          <p className="mb-0">
            Establish a strong presence in the Egyptian market while expanding our reach to international markets.
          </p>
        </div>
        
        <div className="row g-4 justify-content-center">
          {products.map((product, index) => (
            <div key={index} className="col-md-6 col-lg-4 col-xl-3" data-aos="fade-up" data-aos-delay={(index % 4) * 100 + 100}>
              <div className="h-100">
                <a 
                  href={product.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-decoration-none"
                >
                  <div className="blog-content text-dark border p-4 h-100 d-flex flex-column">
                    <h2 className="text-primary mb-3" style={{ fontSize: '1.25rem' }}>{product.name}</h2>
                    <p className="mb-3 flex-grow-1" style={{ fontSize: '0.9rem' }}>{product.description}</p>
                    <div className="text-primary mt-auto align-self-end">
                      Visit {product.name.includes('Dr') ? 'Profile' : 'Profile'} →
                    </div>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </>
}